import BlogCard, { IBlogCard } from "@/components/cards/BlogCard";
import { isEmpty } from "lodash";
import Link from "next/link";
import React, { FC, HTMLAttributes } from "react";

// -------------------------------------------------------------------------------------------------------

export type IUpcomingCoursesSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  courses?: (IBlogCard & { link: string })[];
};

const UpcomingCoursesSection: FC<IUpcomingCoursesSectionProps> = (props) => {
  const { heading, courses, className, ...other } = props;

  if (isEmpty(courses)) return null;

  return (
    <section className="py-5 lg:py-8 xl:py-[50px]" {...other}>
      <div className="bg-primary-100 py-5 dark:bg-black-800 dark:py-10 lg:py-8 dark:lg:py-16 xl:py-[50px] dark:xl:py-[100px]">
        <div className="container">
          {heading && (
            <h2 className="mb-4 text-h7 font-medium text-black-900 dark:text-white md:mb-5 lg:mb-8 lg:text-h4 xl:mb-12 xl:text-h3">
              {heading}
            </h2>
          )}

          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {courses?.map((item) => (
              <BlogCard
                figureWrapperClass="md:h-[184px] lg:h-[153px] xl:h-[213px] w-full"
                link={item.link}
                key={item.link}
                image={item.image}
                heading={item.heading}
                variant="primary"
                className="bg-transparent"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingCoursesSection;
